/** Shared metric column defs for ReportingTable yearly view. */
import { isNeedleAndSharpCategory } from './needleAndSharpPolicy';
import { SIREN_HN_COUNT } from './sirenBundlePolicy';

const QUESTIONS = [
  { label: 'ข้อ1', scoreKey: 'question_1_score', countKey: 'question_1_total', fallbackScoreKey: 'chart_1_score', fallbackCountKey: 'chart_1_total' },
  { label: 'ข้อ2', scoreKey: 'question_2_score', countKey: 'question_2_total', fallbackScoreKey: 'chart_2_score', fallbackCountKey: 'chart_2_total' },
  { label: 'ข้อ3', scoreKey: 'question_3_score', countKey: 'question_3_total', fallbackScoreKey: 'chart_3_score', fallbackCountKey: 'chart_3_total' },
  { label: 'ข้อ4', scoreKey: 'question_4_score', countKey: 'question_4_total', fallbackScoreKey: 'chart_4_score', fallbackCountKey: 'chart_4_total' },
  { label: 'ข้อ5', scoreKey: 'question_5_score', countKey: 'question_5_total', fallbackScoreKey: 'chart_5_score', fallbackCountKey: 'chart_5_total' },
  { label: 'ข้อ6', scoreKey: 'question_6_score', countKey: 'question_6_total', fallbackScoreKey: 'chart_6_score', fallbackCountKey: 'chart_6_total' },
  { label: 'ข้อ7', scoreKey: 'question_7_score', countKey: 'question_7_total', fallbackScoreKey: 'chart_7_score', fallbackCountKey: 'chart_7_total' },
  { label: 'ข้อ8', scoreKey: 'question_8_score', countKey: 'question_8_total', fallbackScoreKey: 'chart_8_score', fallbackCountKey: 'chart_8_total' },
  { label: 'ข้อ9', scoreKey: 'question_9_score', countKey: 'question_9_total', fallbackScoreKey: 'chart_9_score', fallbackCountKey: 'chart_9_total' },
] as const;

/** นิเทศระบบยา (`med_error`): 4 weeks — use chart_* metrics only (not 27 ข้อ columns). */
export const MED_ERROR_WEEK_COLUMNS = [
  { label: 'สัปดาห์ 1', scoreKey: 'chart_1_score', countKey: 'chart_1_total', fallbackScoreKey: 'chart_1_score', fallbackCountKey: 'chart_1_total' },
  { label: 'สัปดาห์ 2', scoreKey: 'chart_2_score', countKey: 'chart_2_total', fallbackScoreKey: 'chart_2_score', fallbackCountKey: 'chart_2_total' },
  { label: 'สัปดาห์ 3', scoreKey: 'chart_3_score', countKey: 'chart_3_total', fallbackScoreKey: 'chart_3_score', fallbackCountKey: 'chart_3_total' },
  { label: 'สัปดาห์ 4', scoreKey: 'chart_4_score', countKey: 'chart_4_total', fallbackScoreKey: 'chart_4_score', fallbackCountKey: 'chart_4_total' },
] as const;

export const isMedErrorSupervisionCategory = (value?: string | null) =>
  value === 'med_error' || value === 'นิเทศระบบยา';

export const isSirenBundleCategory = (value?: string | null) =>
  value === 'siren_bundle' || value === 'SIREN bundle';

/** เข็มตำ/ของมีคมบาด (`needleandsharp`): 10 observation columns. */
export const NEEDLE_AND_SHARP_OCCASION_COLUMNS = Array.from({ length: 10 }, (_, index) => {
  const n = index + 1;
  return {
    label: `ครั้งที่ ${n}`,
    scoreKey: `chart_${n}_score`,
    countKey: `chart_${n}_total`,
    fallbackScoreKey: `chart_${n}_score`,
    fallbackCountKey: `chart_${n}_total`,
  };
});

/** SIREN bundle (`siren_bundle`): 5 HN columns. */
export const SIREN_HN_COLUMNS = Array.from({ length: SIREN_HN_COUNT }, (_, index) => {
  const n = index + 1;
  return {
    label: `HN ${n}`,
    scoreKey: `chart_${n}_score`,
    countKey: `chart_${n}_total`,
    fallbackScoreKey: `chart_${n}_score`,
    fallbackCountKey: `chart_${n}_total`,
  };
});

export const reportingMetricColumnsForCategory = (category?: string | null) => {
  if (isMedErrorSupervisionCategory(category)) return [...MED_ERROR_WEEK_COLUMNS];
  if (isNeedleAndSharpCategory(category)) return [...NEEDLE_AND_SHARP_OCCASION_COLUMNS];
  if (isSirenBundleCategory(category)) return [...SIREN_HN_COLUMNS];
  return [...QUESTIONS];
};
